export const env = {
  baseUrl: "https://api.rxgames.com",
  // baseUrl: "https://cghvn3wno9.execute-api.us-east-1.amazonaws.com/prod", // No trailing slash
  stage: "prod",
  VITE_CLERK_PUBLISHABLE_KEY:"pk_test_a2V5LXBhbmRhLTU5LmNsZXJrLmFjY291bnRzLmRldiQ"
};
